var _circle, _circle2, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _path13, _path14, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 71,
    viewBox: "0 0 255 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5002,
    cy: 35.5009,
    r: 12.2414,
    fill: "url(#paint0_linear_1486_997)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 29.5,
    stroke: "url(#paint1_linear_1486_997)",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.441 12.0237H157.594V34.4431H171.441V28.5085H164.188V25.871H171.441V20.5958H164.188V17.9582H171.441V12.0237Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.833,
    y: 12.0237,
    width: 6.59394,
    height: 23.0788,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.678 12.0239H247.269H247.272H253.863V18.6179H247.272V22.5741H253.863V28.5086H247.272V35.1027H240.678V12.0239Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.048 53.8952V51.917H217.269V53.8952H215.138H207.048Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.367 62.4673C215.622 62.4673 217.269 55.6949 217.269 53.8952H215.138C215.299 56.203 214.17 60.8188 208.367 60.8188C205.873 60.8188 200.983 58.445 200.983 52.9061C200.982 50.0487 202.564 44.334 208.367 44.334C209.687 44.334 214.303 46.3121 214.303 48.9497H216.281C216.281 46.3121 212.325 42.3558 208.368 42.3558C201.511 42.3558 199.357 49.3893 199.137 52.9061C199.137 59.5 204.412 62.4673 208.367 62.4673Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3817 35.4981C104.864 35.4981 110.119 30.0955 110.119 23.4312C110.119 16.7668 104.864 11.3643 98.3817 11.3643C91.8995 11.3643 86.6445 16.7668 86.6445 23.4312C86.6445 30.0955 91.8995 35.4981 98.3817 35.4981ZM98.3838 28.1128C100.642 28.1128 102.472 26.0757 102.472 23.5629C102.472 21.0502 100.642 19.0131 98.3838 19.0131C96.1259 19.0131 94.2956 21.0502 94.2956 23.5629C94.2956 26.0757 96.1259 28.1128 98.3838 28.1128Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.393 34.4433V12.0239H127.262C129.02 12.0239 133.196 13.3427 133.196 18.6179C133.196 21.783 130.998 23.0138 129.899 23.2336C130.998 23.4534 133.856 24.948 133.856 29.1682C133.856 33.3883 129.02 34.4433 127.262 34.4433H115.393ZM121.989 21.2554V17.9584C124.626 17.9584 125.945 18.0247 125.945 19.6072C125.945 21.2554 124.626 21.2554 121.989 21.2554ZM121.989 26.1348V29.4317C124.626 29.4317 125.945 29.4317 125.945 27.7836C125.945 26.2011 124.626 26.1348 121.989 26.1348Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.343 12.0237H143.749V25.871C143.749 27.4535 142.43 27.8491 141.771 27.8491H137.814V34.4431H143.749C149.024 34.4431 150.343 30.0471 150.343 27.8491V12.0237Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.97 25.4753C198.026 31.1663 193.228 35.4983 187.796 35.4983C181.314 35.4983 176.059 30.0958 176.059 23.4314C176.059 16.767 181.314 11.3645 187.796 11.3645C192.843 11.3645 198.016 15.7634 198.978 21.519H191.451C190.779 20.0328 189.395 19.0134 187.798 19.0134C185.54 19.0134 183.71 21.0504 183.71 23.5632C183.71 26.076 185.54 28.113 187.798 28.113C189.442 28.113 190.86 27.0328 191.509 25.4753H198.97Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.163 12.0239H202.041V19.2773H208.371V35.1026H214.965V19.2773H221.163V12.0239Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.194 43.0161H89.3467V44.5987H95.6114V62.4023H97.2599V44.5987H103.194V43.0161Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.465,
    y: 43.0149,
    width: 1.64848,
    height: 19.3862,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.348 46.6801L180.347 43.0137L190.964 58.3894V62.401L180.348 46.6801ZM178.698 43.0149H180.347V62.4011H178.698V43.0149ZM192.615 43.0149H190.966V62.4011H192.615V43.0149Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.198 43.0149H116.056C118.034 43.0149 121.661 44.6844 121.661 48.9494C121.661 50.9276 120.013 54.884 117.111 54.884L122.386 62.1373H120.408L115.133 54.884H110.847V62.1373H109.198V43.0149ZM110.847 44.9931V53.2355H116.056C118.034 53.2355 119.617 51.587 119.617 48.9494C119.617 45.7843 117.155 44.9931 116.056 44.9931H110.847Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.943 62.1373L133.526 43.0149H134.845L142.428 62.1373H140.186L138.34 57.2578H130.032L128.185 62.1373H125.943ZM137.681 55.5434L134.12 46.0481L130.559 55.5434H137.681Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.702 43.0149V62.1373H154.296C157.593 62.1373 162.736 59.6316 162.736 52.2464C162.736 45.6525 157.593 43.0149 154.296 43.0149H147.702ZM149.68 44.6634V60.4888H154.296C156.494 60.3789 160.89 58.5766 160.89 52.2464C160.89 49.6088 158.912 44.6634 154.296 44.6634H149.68Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 223.865,
    y: 54.8845,
    width: 4.28606,
    height: 7.58303,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230.461,
    y: 49.6094,
    width: 4.28606,
    height: 12.8582,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 237.053,
    y: 41.0374,
    width: 4.28606,
    height: 21.4303,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.649,
    y: 44.3342,
    width: 4.28606,
    height: 18.1333,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250.24,
    y: 52.9062,
    width: 4.28606,
    height: 9.56121,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_997",
    x1: 10.55,
    y1: 35.1029,
    x2: 59.3451,
    y2: 35.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B69C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_997",
    x1: -3.16108e-7,
    y1: 35.1024,
    x2: 71.2145,
    y2: 35.1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B69C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ac1eb99140f0b3cbedf720d2f11b7d0.svg";
export { ForwardRef as ReactComponent };